export const soDigitos = (v) => String(v ?? "").replace(/\D/g, "");

export function mascaraDocumento(v) {
  const d = soDigitos(v).slice(0, 14);
  if (d.length <= 11) {
    return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

export function documentoValido(v) {
  const d = soDigitos(v);
  if (d.length === 11) {
    if (/^(\d)\1+$/.test(d)) return false;
    for (const n of [9, 10]) {
      let s = 0;
      for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i);
      if (((s * 10) % 11) % 10 !== Number(d[n])) return false;
    }
    return true;
  }
  if (d.length === 14) {
    if (/^(\d)\1+$/.test(d)) return false;
    const dv = (base, pesos) => {
      const r = base.split("").reduce((a, c, i) => a + Number(c) * pesos[i], 0) % 11;
      return r < 2 ? 0 : 11 - r;
    };
    const p1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    return dv(d.slice(0, 12), p1) === Number(d[12]) && dv(d.slice(0, 13), [6, ...p1]) === Number(d[13]);
  }
  return false;
}

export const brl = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const num = (v, casas = 2) =>
  Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: casas, maximumFractionDigits: casas });

export const dataBR = (iso, comHora = false) => {
  if (!iso) return "";
  const d = new Date(iso);
  return comHora ? d.toLocaleString("pt-BR") : d.toLocaleDateString("pt-BR");
};

export const hojeISO = () => new Date().toISOString().slice(0, 10);
export const inicioMesISO = () => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10);
};

export const round2 = (v) => Math.round((Number(v) + Number.EPSILON) * 100) / 100;

export const UFS = "AC AL AM AP BA CE DF ES GO MA MG MS MT PA PB PE PI PR RJ RN RO RR RS SC SE SP TO".split(" ");

export const STATUS = {
  rascunho: { rotulo: "Rascunho", cor: "bg-gray-100 text-gray-700" },
  processando: { rotulo: "Processando", cor: "bg-amber-100 text-amber-800" },
  autorizada: { rotulo: "Autorizada", cor: "bg-emerald-100 text-emerald-800" },
  rejeitada: { rotulo: "Rejeitada", cor: "bg-red-100 text-red-700" },
  denegada: { rotulo: "Denegada", cor: "bg-red-200 text-red-800" },
  cancelada: { rotulo: "Cancelada", cor: "bg-gray-200 text-gray-600 line-through" },
  erro: { rotulo: "Erro", cor: "bg-red-100 text-red-700" },
  inutilizada: { rotulo: "Inutilizada", cor: "bg-gray-200 text-gray-600" },
  substituida: { rotulo: "Substituída", cor: "bg-gray-200 text-gray-600" },
};

export const FORMAS_PAGAMENTO = [
  ["01", "Dinheiro"], ["03", "Cartão de crédito"], ["04", "Cartão de débito"], ["17", "PIX"],
  ["15", "Boleto"], ["05", "Crédito loja"], ["10", "Vale alimentação"], ["11", "Vale refeição"],
  ["16", "Depósito"], ["18", "Transferência"], ["02", "Cheque"], ["90", "Sem pagamento"], ["99", "Outros"],
];

export const MOD_FRETE = [
  [9, "Sem frete"], [0, "Por conta do emitente (CIF)"], [1, "Por conta do destinatário (FOB)"],
  [2, "Por conta de terceiros"], [3, "Próprio — remetente"], [4, "Próprio — destinatário"],
];

export const REGIMES = [
  ["1", "Simples Nacional"], ["2", "Simples — excesso de sublimite"], ["4", "MEI"],
  ["3P", "Lucro Presumido"], ["3R", "Lucro Real"],
];

export const TIPO_NOTA = { "55": "NF-e", "65": "NFC-e", nfse: "NFS-e" };

export const DESTINACOES = [
  ["revenda", "Revenda"], ["industrializacao", "Industrialização"],
  ["uso_consumo", "Uso e consumo"], ["ativo", "Ativo imobilizado"],
];
